const initialState = {
  printers: {}
}

function checkPrinter (state, action) {
  if (!state.printers[action.place]) {
    state.printers[action.place] = {}
  }
};

function selectPrinter (state, action) {
  checkPrinter(state, action)
  state.printers[action.place].selected = action.printer
  state.printers[action.place].selectedName = action.printerName
};

function requestPrinters (state, action) {
  checkPrinter(state, action)
  state.printers[action.place].requesting = true
  state.printers[action.place].items = []
};

function receivePrinters (state, action) {
  checkPrinter(state, action)
  state.printers[action.place].requesting = false
  state.printers[action.place].items = action.printers
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_PRINTER':
      selectPrinter(state, action)
      return state
    case 'RECEIVE_PRINTERS':
      receivePrinters(state, action)
      return state
    case 'REQUEST_PRINTERS':
      requestPrinters(state, action)
      return state
    default:
      return state
  }
}
